import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { IResponse, Page } from '@models/common.model';
import {
  Cart,
  CartItem,
  CartItemRequest,
  OrderSearchQuery,
  UserOrder,
  UserOrderRequest,
} from '@models/orders.model';
import { EndPoint } from '@constants/api.constant';
import { catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrdersService extends BaseService {
  getCart() {
    return this.http.get<IResponse<Cart>>(EndPoint['cart'].path).pipe(
      catchError(() =>
        of({
          data: {
            items: [],
            orderCode: '',
            paymentPrice: 0,
            totalPrice: 0,
            totalCommissionPrice: 0,
          } as Cart,
          code: 200,
          message: '',
        } as IResponse<Cart>)
      )
    );
  }

  addToCart(request: CartItemRequest) {
    return this.http.post<IResponse<CartItem>>(EndPoint['cart'].path, request);
  }

  updateCartItemQuantity(productId: number, quantity: number) {
    return this.http.put<IResponse<CartItem>>(
      EndPoint['updateCartItemQuantity'].path,
      { productId, quantity }
    );
  }

  removeCartItem(productId: number) {
    return this.http.delete<IResponse<boolean>>(
      `${EndPoint['cart'].path}/${productId}`
    );
  }

  createUserOrder(request: UserOrderRequest) {
    return this.http.post<IResponse<UserOrder>>(
      EndPoint['userOrders'].path,
      request
    );
  }

  updateOrder(request: UserOrderRequest) {
    return this.http.put<IResponse<UserOrder>>(
      EndPoint['orders'].path,
      request
    );
  }

  updateOrderEvidence(id: number, evidenceImage: string) {
    return this.http.put<IResponse<{ id: number }>>(
      `${EndPoint['updateOrderEvidence'].path}/${id}`,
      { evidenceImage }
    );
  }

  cancelOrder(id: number) {
    return this.http.put<IResponse<boolean>>(
      `${EndPoint['cancelOrder'].path}/${id}`,
      {}
    );
  }

  getListOrderUser(params: OrderSearchQuery) {
    return this.http.get<IResponse<Page<UserOrder>>>(EndPoint['orders'].path, {
      params,
    });
  }

  getListOrderNutrishop(params: OrderSearchQuery) {
    return this.http.get<IResponse<Page<UserOrder>>>(
      EndPoint['nutrishopOrders'].path,
      {
        params,
      }
    );
  }

  approveOrder(id: number) {
    return this.http.put<IResponse<boolean>>(
      `${EndPoint['nutrishopOrderApprove'].path}/${id}`,
      {}
    );
  }

  createProxyOrder(userId: number, request: UserOrderRequest) {
    return this.http.post<IResponse<unknown>>(
      `${EndPoint['proxyOrder'].path}/${userId}`,
      request
    );
  }

  getOrderDetail(id: number) {
    return this.http.get<IResponse<UserOrder>>(
      `${EndPoint['orderDetail'].path}/${id}`
    );
  }

  getOrderCount() {
    return this.http.get<
      IResponse<{
        pending: number;
        approved: number;
        completed: number;
        canceled: number;
      }>
    >(EndPoint['countOrder'].path);
  }
}
